module.exports = __webpack_public_path__ + "static/media/ico-floating-profile-active.1e5b2f1b.svg";